export default __webpack_public_path__ + "static/homepage-my-tasks-screenshot-389aa704b32b75389ac54278b96062bf.png";